// extracted by mini-css-extract-plugin
export default {"widgets":"_1dbeda3c908a5c86","column":"_5bc625b49022115b","widget":"_2e96fb3ad66dadaa"};